import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { BancoService } from './services/banco.service';
import { IBanco, IBancoResponse } from './interfaces/banco.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-bancos',
  templateUrl: './abc-bancos.component.html',
  providers: [MessageService]
})
export class AbcBancosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedBanco: IBanco | null = null;
  dataSource: IBanco[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'banco', header: 'Banco', sortable: true },
    { field: 'nombre', header: 'Nombre Banco', sortable: true },
    { field: 'tipoTarjeta', header: 'Tipo Tarjeta', sortable: true },
    { field: 'numeroCuenta', header: 'Número Cuenta', sortable: true },
    { field: 'cuentaContable', header: 'Cuenta Contable', sortable: true },
    { field: 'iOrigenMov', header: 'Movement Origin', sortable: true },
    { field: 'iOrigenDisp', header: 'Dispersion Origin', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private bancoService: BancoService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    
    this.bancoService.getBancosDefault().subscribe({
      next: (response: IBancoResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los bancos'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los bancos'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedBanco = null;
    this.displayDialog = true;
  }

  openUpdate(row: IBanco): void {
    this.selectedBanco = { ...row };
    this.displayDialog = true;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  onCancelled(): void {
    this.displayDialog = false;
  }

  openDelete(row: IBanco): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea eliminar el banco ${row.banco}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        this.bancoService.deleteBanco(row.banco).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Banco eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar el banco'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el banco'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedBanco = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }
}
